'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProgressStatus.scss');

var ProgressStatus = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProgressStatus, _Component);

  function ProgressStatus() {
    (0, _classCallCheck3.default)(this, ProgressStatus);
    return (0, _possibleConstructorReturn3.default)(this, (ProgressStatus.__proto__ || (0, _getPrototypeOf2.default)(ProgressStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProgressStatus, [{
    key: 'getBarStyle',
    value: function getBarStyle() {
      var _props = this.props,
          countAll = _props.countAll,
          count = _props.count;

      var percents = count / countAll * 100;
      return { width: percents + '%' };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          containerClassName = _props2.containerClassName,
          barClassName = _props2.barClassName;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.container, containerClassName) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.bar, barClassName), style: this.getBarStyle() })
      );
    }
  }]);
  return ProgressStatus;
}(_react.Component), _class.propTypes = {
  barClassName: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  count: _propTypes2.default.number,
  countAll: _propTypes2.default.number
}, _temp);
exports.default = ProgressStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProgressStatus/ProgressStatus.js
// module id = 2045
// module chunks = 1